module.exports = __webpack_public_path__ + "static/media/21ECLAC52.35112a10.jpg";